import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	superbatchCSSRecorder,
	superbatchJSRecorder,
} from '@confluence/ssr-utilities/entry-points/SuperbatchResourceRecorder.ts';
import { removeJquery, convertSuperBatchResourceToTags } from '@confluence/dom-helpers';

import requireSuperBatchFrontendResourceRenderQuery, {
	type requireSuperBatchFrontendResourceRenderQuery$data,
	type requireSuperBatchFrontendResourceRenderQuery$variables,
} from './helpers/__generated__/requireSuperBatchFrontendResourceRenderQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export async function preloadSuperBatchData({
	preloadSuperBatchForSSR = false,
}: {
	preloadSuperBatchForSSR?: boolean;
} = {}): Promise<void | {
	data: requireSuperBatchFrontendResourceRenderQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	if (preloadSuperBatchForSSR) {
		const superbatchData = await query<
			requireSuperBatchFrontendResourceRenderQuery$data,
			requireSuperBatchFrontendResourceRenderQuery$variables
		>({ query: requireSuperBatchFrontendResourceRenderQuery });
		const resourceList =
			(superbatchData?.data as any)?.internalFrontendResource?.resourceList || [];
		const { js, css } = resourceList.reduce(
			(
				acc: { js: string[]; css: string[] },
				resource: {
					url: string;
					type: 'css' | 'js';
					attributes: Array<{ key: string; value: string }>;
					__typename: string;
				},
			) => {
				const html = convertSuperBatchResourceToTags(resource);
				acc[resource.type].push(html);
				return acc;
			},
			{ js: [], css: [] },
		);

		superbatchJSRecorder.add(removeJquery(js.join('\n')));
		superbatchCSSRecorder.add(css.join('\n'));
	} else if (
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		!process.env.REACT_SSR &&
		!window.__SUPERBATCH_REQUESTED__
	) {
		return query<
			requireSuperBatchFrontendResourceRenderQuery$data,
			requireSuperBatchFrontendResourceRenderQuery$variables
		>({ query: requireSuperBatchFrontendResourceRenderQuery });
	}
	return Promise.resolve();
}
